import { useTranslation } from 'react-i18next';

import { useLanguageContext } from './language-context';

export const useLocalize = () => {
  const res = useTranslation();
  const { lang } = useLanguageContext();

  return { ...res, language: lang ?? 'EN' };
};
